import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent } from '@xanadu/core';
import { BatchSignal, TreeSignal } from '@xanadu/signal';
import { Content, ContentModel, PrototypeModel, Site, ViewFields } from '@xanadu/model';
import { AspectCache } from '../../cache/aspect.cache';
import { PrototypeCache } from '../../cache/prototype.cache';

@Component({
    selector: 'content-base',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class ContentBaseComponent extends PanelComponent<Content> {
    private readonly aspectCache = inject(AspectCache);
    private readonly prototypeCache = inject(PrototypeCache);

    protected readonly treeSignal = inject(TreeSignal);
    protected readonly batchSignal = inject(BatchSignal);

    protected get nodeType(): string | undefined {
        return 'content';
    }

    prototypeModel?: PrototypeModel;
    contentModel?: ContentModel;

    constructor() {
        super();

        effect(() => {
            const model = this.model();
            const content = this.node();
            const aspects = this.aspectCache.signal();
            const prototypes = this.prototypeCache.signal();

            if (content && prototypes) {
                const viewFields = new ViewFields(content, model.custome, prototypes, aspects);

                this.prototypeModel = viewFields.prototypeModel;
                this.contentModel = viewFields.contentModel;
            }
        });
    }
}
